<template>
  <div class="con-wrap">
    <el-form
      size="medium"
      :inline="true"
      :model="queryForm"
      ref="queryForm"
      class="input-form-inline"
    >
      <el-form-item class="r-20" prop="code">
        <el-input v-model="queryForm.name" placeholder="站址名称"></el-input>
      </el-form-item>

      <el-button size="medium" v-if="hasPerm('base:station:addr:list')" type="primary" @click="query">查询</el-button>
      <el-button size="medium" v-if="hasPerm('base:station:addr:list')" @click="reset">取消</el-button>
    </el-form>
    <el-table
      ref="logTable"
      :data="tableData"
      tooltip-effect="dark"
      style="width: 100%"
      stripe
      size="mini"
      height="560px"
    >
      <el-table-column type="index" align="center" label="序号" width="55"></el-table-column>
      <el-table-column prop="stationName" label="站址名称"></el-table-column>
      <el-table-column prop="stationCode" label="站址编码"></el-table-column>
      <el-table-column prop="areaName" label="归属区域"></el-table-column>
      <el-table-column prop="type" label="路径类型">
          <template slot-scope="scope">
              <span v-if="scope.row.type==1">基站路径</span>
              <span v-if="scope.row.type==2">油机口</span>
          </template>
      </el-table-column>
      <el-table-column prop="personnelName" label="上传者">
          <template slot-scope="scope">
              <span>{{scope.row.personnelName}}（{{scope.row.plate}}）</span>
          </template>
      </el-table-column>
      <el-table-column prop="addTime" label="上传时间"></el-table-column>
      <el-table-column label="操作">
          <template slot-scope="scope">
              <el-button type="text" v-if="hasPerm('base:station:addr:review')" @click.native="gotoAudit(scope.row)">审核</el-button>
          </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page.sync="currentPage"
      :page-size="limit"
      layout="total, prev, pager, next, jumper"
      :total="total"
    ></el-pagination>
  </div>
</template>

<script>
export default {
  data () {
    return {
        queryForm: {
            name: ''
        },
        currentPage: 1,
        limit: 10,
        total: 0,
        tableData: []
    }
  },
  created () {
    this.getPathList()
  },
  methods: {
    gotoAudit(data){
        this.$router.push({
            name: 'Audit', 
            params: { 
                id: data.id, 
                stationCode: data.stationCode
            }
        })
    },
    query () {
      this.getPathList()
    },
    reset () {
      this.$resetForm(this, 'queryForm')
      this.getPathList()
    },
    async getPathList () {
      let parm = {}
      parm.name = this.queryForm.name
      parm.pageSize = this.limit;
      parm.pageNum = this.currentPage;
      let _this = this;
      let { data: res } = await _this.$axios.get(
        "/api/base/station/addr/list",
        { params: parm }
      )
      if (res.code == 1) {
        _this.tableData = res.data.list;
        _this.total = res.data.totalCount
      }
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.getPathList()
    },
    handleSizeChange (val) {
      console.log(val)
    }
  }
}
</script>

<style lang="scss" scoped>
.con-wrap {
  background-color: #fff;
  padding: 0 20px;
}
.pathMap{
    width: 100%;
    height:100%;
    box-sizing: border-box;
    padding:20px!important;
    .main{
        width:100%;
        height: calc(100% - 25px);
        padding-top:20px;
        position: relative;
        .imgList{
            position: absolute;
            box-sizing: border-box;
            width: 190px;
            height: calc(100% - 50px);
            overflow: auto;
            background: #FFFFFF;
            padding:10px 20px;
            z-index:9;
            left:15px;
            top:35px;
            .time{
                font-size: 14px;
                font-family: Microsoft YaHei;
                font-weight: bold;
                color: #333333;
            }
            .userMess{
                font-size: 14px;
                font-family: Microsoft YaHei;
                font-weight: bold;
                color: #333333;
            }
            .active{
                border: 1px solid #0094FF;
            }
            .imgItem{
                box-sizing: border-box;
                width:150px;
                height:110px;
                margin:10px 0!important;
                position: relative;
                cursor: pointer;
                .sortIndex{
                    position: absolute;
                    left:5px;
                    top:5px;
                    width:20px;
                    height:20px;
                    text-align: center;
                    line-height: 20px;
                    background: #fff;
                    border-radius: 50%;
                    font-size: 14px;
                    font-family: Source Han Sans CN;
                    font-weight: 400;
                    color: #333333;
                    z-index:99

                }
                .imgBox{
                    width:100%;
                    height:100%;
                }
            }
        }
        .mapWrapper{
            height:100%;
            width:100%;
        }
    }
    .infoWindow{
      width: 170px;
    background: #FFFFFF;
    border: 1px solid #999999;
    border-radius: 8px;
    padding:5px;
    position: relative;
    .imgBox{
        width:100%;
        height:100%;
    }
    .desc{
        word-wrap:break-word;
        font-size: 14px;
        line-height: 20px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
    }
  }
  .infoWindow:before{
        box-sizing: content-box;
        width: 0px;
        height: 0px;
        position: absolute;
        bottom: -16px;;
        right:80px;
        padding:0;
        border-top:8px solid #FFFFFF;
        border-bottom:8px solid transparent;
        border-left:8px solid transparent;
        border-right:8px solid transparent;
        display: block;
        content:'';
        z-index: 12;
    }
    .infoWindow:after{
        box-sizing: content-box;
        width: 0px;
        height: 0px;
        position: absolute;
        bottom: -18px;;
        right:80px;
        padding:0;
        border-top:9px solid #999;
        border-bottom:9px solid transparent;
        border-left:9px solid transparent;
        border-right:9px solid transparent;
        display: block;
        content:'';
        z-index:10
    }
}

.imgList::-webkit-scrollbar {
  /*滚动条整体样式*/
  width : 2px;  /*高宽分别对应横竖滚动条的尺寸*/
  height: 1px;
  }
  .imgList::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 2px;
  box-shadow   : inset 0 0 1px rgba(0, 0, 0, 0.7);
  background   : #999;
  }
  .imgList::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  box-shadow   : inset 0 0 1px rgba(0, 0, 0, 0.7);
  border-radius: 2px;
  background   : #ededed;
  }
</style>